<script>
import {enablePushNotifications, reloadPushNotifications} from "./services/NotificationRequestService";

require('./app-bootstrap');
require('vue-tour/dist/vue-tour.css')

import VueWait from "vue-wait";
import Vue from "vue";
import Notifications from "vue-notification";
import browserDetect from "vue-browser-detect-plugin";
import VueMoment from "vue-moment";
import moment from "moment";
import VueNativeNotification from "vue-native-notification";
import VCalendar from "v-calendar";
import {vCalendarSq} from "./services/CalendarLocaleSQ";
import VueTour from 'vue-tour'
import VueSlideoutPanel from 'vue2-slideout-panel';
import {eventBus} from "./services/EventBus";
import {Dropdown} from "bootstrap";
import {getSessionSpace} from "./services/SessionService";

Vue.prototype.trans = require('./VueTranslation/Translation').default.translate;

Vue.use(VueTour)
Vue.use(VueSlideoutPanel);
Vue.use(Notifications);
Vue.use(browserDetect);
Vue.use(VueMoment, {moment});
Vue.use(VueNativeNotification, {requestOnNotify: false});
Vue.use(VueWait);
Vue.use(VCalendar, {locales: {'sq': vCalendarSq},});
Vue.use(eventBus);

Vue.component('set-password', require('./theme/organisms/SetPassword').default);
Vue.component('search-bar-desktop', require('./theme/organisms/SearchBarDesktop').default);
Vue.component('search-modal', require('./theme/organisms/SearchModal').default);
Vue.component('notifications-tray', require('./widgets/NotificationPanelWidget/molecules/NotificationsTray.vue').default);
Vue.component('changelog', require('./theme/organisms/ChangeLog').default);
Vue.component('space-setup', require('./widgets/SpaceSetup/SpaceSetup.vue').default);
Vue.component('trial-alert', require('./theme/organisms/TrialAlert.vue').default);
Vue.component('upgrade-button', require('./theme/atoms/UpgradeButton.vue').default);
Vue.component('help-button', require('./theme/organisms/HelpButton.vue').default);
Vue.component('tour-nav', require('./theme/organisms/TourNav.vue').default);
Vue.component('change-logo', require('./widgets/SpaceSetup/molecules/ChangeLogo.vue').default);
Vue.component('payment-documentation-panel', require('./modules/SpaceBilling/molecules/PaymentDocumentationPanel.vue').default);
Vue.component('invoice-documentation-panel', require('./modules/SpaceBilling/molecules/InvoiceDocumentationPanel.vue').default);
Vue.component('invoice-form', require('./modules/SpaceBilling/organisms/InvoiceForm/InvoiceForm.vue').default);
Vue.component('payment-form', require('./modules/SpaceBilling/molecules/PaymentForm.vue').default);
Vue.component('send-message', require('./theme/organisms/QuickCallToActions/SendMessage.vue').default);
Vue.component('plan-menu', require('./theme/organisms/QuickCallToActions/PlanMenu.vue').default);
Vue.component('create-activity', require('./theme/organisms/QuickCallToActions/CreateActivity.vue').default);
Vue.component('create-event', require('./theme/organisms/QuickCallToActions/CreateEvent.vue').default);
Vue.component('schedule-meeting', require('./theme/organisms/QuickCallToActions/ScheduleMeeting.vue').default);
Vue.component('create-invoice', require('./theme/organisms/QuickCallToActions/CreateInvoice.vue').default);
Vue.component('observe-children', require('./theme/organisms/QuickCallToActions/ObserveChildren.vue').default);
Vue.component('add-child', require('./theme/organisms/QuickCallToActions/AddChild.vue').default);
Vue.component('create-form', require('./theme/organisms/QuickCallToActions/CreateForm.vue').default);
Vue.component('daily-report', require('./widgets/DailyReportWidget/DailyReport.vue').default);
Vue.component('warning-messages', require('./theme/organisms/WarningMessages.vue').default);
Vue.component('attendance-clock-widget', require('./widgets/AttendanceClockWidget/organisms/AttendanceClockWidget.vue').default);
Vue.component('transfer-to-new-domain-widget', require('./widgets/TansferToNewDoaminWidget/TransferToNewDomainWidget.vue').default);

export default {
    el: '#app',
    name: "app",
    data() {
        return {
            initTimezone: true,
            lang: document.documentElement.lang,
            isToggled: localStorage.getItem('isToggled') === 'true',
            callToActionComponents: {
                'create-invoice': false,
                'schedule-meeting': false,
                'create-activity': false,
                'plan-menu': false,
                'send-message': false,
                'create-event': false,
                'report-children': false,
                'observe-children': false,
                'add-child': false,
                'daily-report': true,
            },
            bodyTag: document.getElementsByTagName('body')[0].classList,
        }
    },
    created() {
        eventBus.$on('openObserveChildren', (data) => {
            this.callToAction('observe-children', data)
        });
        eventBus.$on('callToAction', (action, data) => {
            this.callToAction(action, data);
        });
    },
    watch: {
        isToggled: function (val) {
            if (window.innerWidth <= 768) {
                if (val) {
                    this.bodyTag.remove('disable-scroll');
                } else {
                    this.bodyTag.add('disable-scroll');
                }
            } else {
                this.bodyTag.remove('disable-scroll');
            }

            localStorage.setItem('isToggled', val);
            this.adjustContentWrapperMarginTop();
        }
    },
    methods: {
        toggleSideBar(width) {
            (width <= 768) ? this.isToggled = true : this.isToggled = this.isToggled || false;
            this.adjustContentWrapperMarginTop();
        },

        switchSidebarDropupClasses() {
            const sidebarDropupButton = document.getElementById('sidebarDropupButton');

            if (window.innerWidth <= 768) {
                sidebarDropupButton.classList.remove('dropend');
                sidebarDropupButton.classList.add('dropup');
            } else {
                sidebarDropupButton.classList.remove('dropup');
                sidebarDropupButton.classList.add('dropend');
            }
        },

        showUpgradeButtonState(state) {
            this.$refs.upgradeBtn.changeState(state);
        },

        openSearchModal: function () {
            this.$refs.searchModal.open()
        },

        requestNotificationPermission: function () {
            const isIOS = (this.$browserDetect.isIOS || this.$browserDetect.isSafari)
            if ((!isIOS || this.$browserDetect.isChromeIOS) && location.pathname !== "/auth") {
                enablePushNotifications();
                reloadPushNotifications();
            }
        },

        initSidebarEvents: function () {
            if (document.getElementById("sidebarToggleTop"))
                document.getElementById("sidebarToggleTop").addEventListener("click", function () {
                    document.getElementById("sidebarToggle").click();
                });
        },

        initTooltips: function () {
            setTimeout(() => {
                [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
                    .map(function (tooltipTriggerEl) {
                        return new bootstrap.Tooltip(tooltipTriggerEl)
                    })
            }, 1000)
        },

        callToAction(action, data = null) {
            this.$set(this.callToActionComponents, action, true);

            this.$nextTick(() => {
                if (this.$refs[action]) {
                    this.$refs[action].init(data);
                }
            });
        },

        reloadOverviewCards() {
            if (this.$refs.dashboard) {
                this.$refs.dashboard.reloadOverviewCards();
            }
        },

        reloadEvents() {
            if (this.$refs.dashboard) {
                this.$refs.dashboard.reloadEvents();
            }
        },

        reloadTodayReports(data) {
            eventBus.$emit('reloadTodayReports', data);
        },

        openDailyReport({ child, group }) {
            const dailyReport = this.$refs['daily-report'];

            dailyReport.setClass(null);
            dailyReport.setChild(null);

            if (child) {
                dailyReport.setChild(child);
            } else if (group) {
                dailyReport.setClass(group);
            }

            dailyReport.open();
        },

        handleDropdownClick(event) {
            const target = event.target.closest('.dropdown-toggle');
            if(target && target.classList.contains('dropdown-toggle') && !target.classList.contains('show')) {
                const dropdown = Dropdown.getInstance(target);
                dropdown.hide();
                return;
            }

            const dropdownMenu = event.target.closest('.dropdown-menu');
            if (dropdownMenu) {
                const closestDropdown = dropdownMenu.closest('.dropdown');
                if (closestDropdown) {
                    const dropdownToggle = closestDropdown.querySelector('.dropdown-toggle');
                    if (dropdownToggle && dropdownToggle.getAttribute('data-bs-auto-close') === 'false') {
                        return;
                    }
                }
            }

            document.querySelectorAll('.dropdown-toggle').forEach((toggle) => {
                const dropdown = Dropdown.getInstance(toggle);
                if (dropdown && dropdown._element.classList.contains('show')) {
                    dropdown.hide();
                }
            });

            const dropdownToggle = event.target.closest('.dropdown-toggle');
            if (dropdownToggle) {
                const dropdown = Dropdown.getOrCreateInstance(dropdownToggle);
                dropdown.toggle();
            }
        },

        handleClick(event) {
            this.handleDropdownClick(event);
        },

        async setGlobalTimezone() {
            if(!this.initTimezone) {
                return;
            }
            const space = await getSessionSpace();

            if(space?.timezone) {
                moment.tz.setDefault(space.timezone);
            }
        },

        adjustContentWrapperMarginTop() {
            this.$nextTick(() => {
                const topBar = document.getElementById('topbar');
                const contentWrapper = document.getElementById('content-wrapper');

                if (topBar && contentWrapper) {
                    contentWrapper.style.marginTop = `${topBar.offsetHeight}px`;
                }
            });
        },
    },
    mounted() {
        this.setGlobalTimezone();
        this.toggleSideBar(window.innerWidth);
        this.switchSidebarDropupClasses();
        this.requestNotificationPermission();
        this.initSidebarEvents();
        this.initTooltips();

        if (this.$refs.appTour && this.$refs.tourNav) {
            this.$refs.tourNav.setTour(this.$refs.appTour);
        }

        this.$nextTick(() => {
            document.addEventListener('click', this.handleClick, true);
            window.addEventListener('resize', () => {
                this.toggleSideBar(window.innerWidth);
                this.switchSidebarDropupClasses();

                clearTimeout(this.resizeTimeout);
                this.resizeTimeout = setTimeout(() => {
                    this.adjustContentWrapperMarginTop();
                }, 100);
            });
        });
    }
}
</script>
